export default {
    shippings: {},
    shippingMethod: null,
    loadingCalculate: false,
    cepDestination: null
}
  